module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/2CWKdA7XMAMSG4acwoK86m-0bfd1b0d9587ce4bae3428b54c457d9e.jpg";